module.exports = __webpack_public_path__ + "static/media/logo-full.16117025.svg";